import { GenericResponseWithPayload, POST } from "../../../utils/api";
import { getRefreshTokenFromCookies } from "../../../utils/authUtils";
import { LoginPageFormModel } from "../types";

const mapLoginBody = (data: LoginPageFormModel) => {
  const { emailOrUsername, password } = data;

  return {
    userName: emailOrUsername,
    password: password,
  };
};

export interface LoginResponse {
  userId: string;
  email: string;
  userName: string;
  roles: string[];
  token: string;
  tokenExpiresAtUtc: string;
  refreshToken: string;
  refreshTokenExpiresAtUtc: string;
}

export const loginUser = (
  data: LoginPageFormModel,
): Promise<GenericResponseWithPayload<LoginResponse>> => {
  const body = mapLoginBody(data);
  return POST<GenericResponseWithPayload<LoginResponse>>("/auth/login", body);
};

export const refreshToken =
  (() => {
    let refreshPromise:
      | Promise<GenericResponseWithPayload<LoginResponse> | null>
      | null = null;

    return async (): Promise<GenericResponseWithPayload<LoginResponse> | null> => {
      if (refreshPromise) return refreshPromise;

      const refreshTokenValue = getRefreshTokenFromCookies();
      if (!refreshTokenValue) {
        return {
          success: false,
          data: null,
          message: "No refresh token found",
        } as GenericResponseWithPayload<LoginResponse>;
      }

      refreshPromise = POST<GenericResponseWithPayload<LoginResponse>>(
        "/auth/refresh",
        {
          refreshToken: refreshTokenValue,
        },
      ).finally(() => {
        refreshPromise = null;
      });

      return refreshPromise;
    };
  })();
